<div id="panel-group" class="panel-container mt-6">
  @for (item of items; track item; let i = $index) {
    <div class="panel-section" [class.expand-panel]="current === i">
      <div class="panel-heading" (click)="expandCollapse(i, $safeNavigationMigration(item?.fields?.question))" (keydown.enter)="expandCollapse(i, $safeNavigationMigration(item?.fields?.question))" tabindex="0" role="button">
        <h5 class="panel-title">
          <span>{{ item?.fields?.question }}</span>
          <i class="chevron down" [class.down]="i !== current" [class.top]="i === current" aria-hidden="true"></i>
          <span class="sr-only">Toggle Section</span>
        </h5>
      </div>
      <div class="panel-collapse" [class.collapse]="current !== i">
        <div class="panel-body">{{ item?.fields?.answer }}</div>
      </div>
    </div>
  }
</div>
@if (!items.length) {
  <div>No records found.</div>
}
